module.exports = __webpack_public_path__ + "pc-static/img/2.548f7ea.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/2.jpg
// module id = Mn6R
// module chunks = 1